/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Controllers.Login = class Login {
  constructor(el) {
    this.startProgressButton = this.startProgressButton.bind(this);
    this.showHideTooltip = this.showHideTooltip.bind(this);
    this.updateButtonAndTooltip = this.updateButtonAndTooltip.bind(this);
    this.sendJoinEmail = this.sendJoinEmail.bind(this);
    this._sendJoinEmailSuccess = this._sendJoinEmailSuccess.bind(this);
    this._allFieldsValid = this._allFieldsValid.bind(this);
    this.el = el;
    this.view = new Buyapowa.Views.Login(this.el, this);
    this.pb = new Buyapowa.Helpers.ProgressButton(this.el.find('button.login-or-register'));

    this.view.onKeyPressed(this.updateButtonAndTooltip);
    this.view.onEmailBlur(this.showHideTooltip);
    this.view.onButtonClick(this.startProgressButton);
    this.view.onResendJoinEmailSubmit(this.sendJoinEmail);

    if (this.view.alreadySignedUp() && window.FS) {
      FS.setUserVars({'resendJoinEmail_bool' : true});
    }

    if (!this.view.alreadySignedUp()) {
      this.updateButtonAndTooltip();
    }
  }

  startProgressButton() {
    return this.pb.started(this.view.buttonProgressText());
  }

  showHideTooltip() {
    if (this.view.emailValid()) {
      return this.view.hideTooltip();
    } else {
      return this.view.showTooltip(this.view.invalidEmailTooltip());
    }
  }

  updateButtonAndTooltip() {
    if (this._allFieldsValid()) {
      this.view.enableButton();
      this.view.hideTooltip();
    } else {
      this.view.disableButton();
    }

    return this.view.toggleTick();
  }

  sendJoinEmail(event) {
    event.preventDefault();
    return $.ajax({
      method: 'post',
      url: this.view.getResendJoinEmailUrl(),
      data: this.view.getResendJoinEmailData()
    }).done(this._sendJoinEmailSuccess);
  }

  _sendJoinEmailSuccess() {
    return this.view.showJoinEmailSuccess();
  }

  _allFieldsValid() {
    const fields = ['email', 'fullName', 'firstName', 'lastName', 'termsOptIn', 'emailComplianceOptIn', 'marketingOptIn', 'customField'];
    for (var i of Array.from(fields)) {
      if (!this.view[`${i}Valid`]()) { return false; }
    }

    return true;
  }
};
